import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import Rail from './Rail.js';

var RangeSelection = function RangeSelection(props) {
  return React__default.createElement(Rail, _extends({}, props, {
    selected: true
  }));
};
var RangeSelection$1 = RangeSelection;

export { RangeSelection$1 as default };
//# sourceMappingURL=RangeSelection.js.map
